module.exports = __webpack_public_path__ + "static/media/ai-report.2cfe6ff2.png";